




































import Vue from 'vue'
import SignInUpCommon from '@/components/user/SignInUpCommon.vue'

export default Vue.extend({
  name: 'SetupNewPassword',
  components: {
    SignInUpCommon,
  },
  data: () => ({
    password: '',
    showPassword: false,
    passwordRules: [
      (v: string) => !!v || 'New password is required.',
      (v: string) =>
        v.length >= 8 || 'New password must be at least 8 characters long.',
    ],
  }),
  methods: {
    setupNewPassword: function () {
      this.$api
        .post('/reset_password/reset/' + this.$route.params.token, {
          password: this.password,
        })
        .then(() => {
          this.$store.dispatch(
            'alert/success',
            'Password changed. Now sign in with the new password.'
          )
          this.$router.push('/sign-in')
        })
        .catch(() =>
          this.$store.dispatch('alert/error', 'Something gone wrong.')
        )
    },
  },
})
